type ToastShow = (message: string, tone?: "info" | "success" | "danger") => void;

export function reportSaved(show: ToastShow, message = "Saved.") {
  show(message, "success");
}

/** Shows why a Save click did not persist, and returns that text for the inline alert. */
export function reportSaveFailure(show: ToastShow, error: unknown, fallback: string): string {
  const message = error instanceof Error && error.message.trim() ? error.message : fallback;
  show(message, "danger");
  return message;
}

/** A check on the form failed before anything was written. */
export function reportSaveBlocked(show: ToastShow, message: string): string {
  show(message, "danger");
  return message;
}
